var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bizcomp-assets box"},[_c('el-tabs',{staticClass:"tab",model:{value:(_vm.activeType),callback:function ($$v) {_vm.activeType=$$v},expression:"activeType"}},[_c('el-tab-pane',{attrs:{"name":"assets","label":"资产总览"}},[_c('my-assets',{ref:"assets"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }